import { render } from "./Big2Form.vue?vue&type=template&id=34a79818&scoped=true"
import script from "./Big2Form.vue?vue&type=script&lang=js"
export * from "./Big2Form.vue?vue&type=script&lang=js"

import "./Big2Form.vue?vue&type=style&index=0&id=34a79818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a79818"]])

export default __exports__